import { Button, Container, Title } from '@/components'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from 'next/image'

import ftgYellowIcon from '/public/icons/fgt-yellow.svg'

import useCases from './hooks'

import styles from './styles.module.scss'

import useClickWithScroll from '@/utils/browser/useClickWithScroll'

const Cases = ({ bgImage, customClass, isPink = false }) => {
  const { onClickItem } = useClickWithScroll()
  const { itens, settings } = useCases()

  return (
    <section
      className={`fgt-section ${styles.cases} ${customClass}`}
      id="cases"
    >
      <Container>
        <Title
          Tag="h2"
          alignText="center"
          variant={isPink ? 'pink' : ''}
          colorText={'light'}
        >
          MAIS DE 400.000 ALUNOS TAMBÉM <span>COMEÇARAM DO ZERO</span>
        </Title>
        <p className={`fgt-subtitle ${styles.subtitle}`}>
          Com nossos treinos testados e aprovados por especialistas, você só
          precisa de 30 minutos por dia para ter esses mesmos resultados
          extraordinários.
        </p>
      </Container>

      <Swiper {...settings} className={`fgt-swiper ${styles.carrossel}`}>
        {itens.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className={styles.item} key={index}>
                <Image
                  className={styles.image}
                  src={item.path}
                  alt={item.name}
                  width={300}
                  height={300}
                />
                <div className={styles.infos}>
                  <div className={styles.header}>
                    <div className={styles.name}>
                      <Image
                        src={ftgYellowIcon}
                        alt="Icone do FGT"
                        width={23}
                        height={21}
                      />
                      <p>{item.name}</p>
                    </div>
                    <p className={styles.instagram}>{item.instagram}</p>
                  </div>
                  <div className={styles.content}>
                    <div className={styles.left}>
                      <p className={styles.text}>{item.age}</p>
                      <p className={styles.text}>{item.trainingTime}</p>
                    </div>
                    <p className={styles.progressWeight}>{item.weight}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          )
        })}
      </Swiper>

      <div className="fgt-section__action">
        <Button
          id="btn-section-cases"
          variant="primary"
          className={'fgt-section__action--button'}
          onClick={() => {
            onClickItem('comparePlans', 0)
          }}
        >
          QUERO MEU PRÓPRIO ANTES E DEPOIS
        </Button>
      </div>
    </section>
  )
}

export default Cases
